import { Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../../../../hooks/auth';
import { useToast } from '../../../../../../hooks/toast';
import {
  ButtonsWrapper,
  StatusSaleButton,
} from '../../../../../Produtos/components/styles';
import {
  ButtonStyled,
  InformativeSpan,
  PageTitle,
  Wrapper,
} from '../../styles';
import api from '../../../../../../services/api';

const Inventory: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();

  const [inventoryControl, setInventoryControl] = useState(false);

  const handleSubmitInventoryControl = useCallback(async () => {
    try {
      await api.post(`/parametro`, {
        descricao: 'controle_estoque',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: inventoryControl,
        }),
      });

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  }, [inventoryControl, user, addToast]);

  useEffect(() => {
    async function loadInventoryControl(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'controle_estoque',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);

          setInventoryControl(role.status);
        }
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
      }
    }

    loadInventoryControl();
  }, [user.empresa_id, addToast]);

  return (
    <Wrapper style={{ paddingLeft: 50, paddingRight: 50 }}>
      <Grid container spacing={3} style={{ marginTop: 30 }}>
        <Grid item xs={12}>
          <PageTitle>Controle de estoque</PageTitle>
          <InformativeSpan style={{ paddingTop: 10, maxWidth: 800 }}>
            Ao habilitar está função a loja só exibirá os produtos que contem
            estoque positivo em seu cadastro (estoque atual).
          </InformativeSpan>
          <Grid
            container
            justify="center"
            style={{ display: 'block', paddingBottom: 60, paddingTop: 30 }}
          >
            <Grid item xs={12}>
              <Grid
                item
                lg={4}
                md={6}
                xs={12}
                style={{ marginLeft: 15, maxWidth: 160 }}
              >
                <span>Habilitado:</span>

                <ButtonsWrapper
                  style={{
                    marginTop: 8,
                    justifyContent: 'flex-start',
                  }}
                >
                  <div
                    onClick={(event) => event.stopPropagation()}
                    onFocus={(event) => event.stopPropagation()}
                  >
                    <StatusSaleButton
                      type="button"
                      isPaused={inventoryControl}
                      className="paused"
                      onClick={() => setInventoryControl(false)}
                    >
                      Desabilitado
                    </StatusSaleButton>

                    <StatusSaleButton
                      type="button"
                      isPaused={!inventoryControl}
                      className="activated"
                      onClick={() => setInventoryControl(true)}
                    >
                      Habilitado
                    </StatusSaleButton>
                  </div>
                </ButtonsWrapper>
              </Grid>
              <Grid container justify="center" style={{ paddingTop: 30 }}>
                <Grid item lg={4} md={6} xs={12}>
                  <ButtonStyled
                    type="button"
                    onClick={handleSubmitInventoryControl}
                  >
                    Salvar
                  </ButtonStyled>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default Inventory;
